import {useFetch} from "../../../../../../../layout/hooks/useFetch";
import {DataTable, DataTableRowToggleEvent} from "primereact/datatable";
import {Column} from "primereact/column";
import React, {useContext, useRef, useState} from "react";
import {Button} from "primereact/button";
import {ParkingCampusFloor} from "../../../../../../../types/demo";
import {confirmPopup, ConfirmPopup} from "primereact/confirmpopup";
import {Toast} from "primereact/toast";
import {LayoutContext} from "../../../../../../../layout/context/LayoutContext";
import {handleDelete} from "../../../../../../../utils/helper";

interface CampusFloorDetailsProps {
    campusId: number,
    setFloorsModal: React.Dispatch<React.SetStateAction<boolean>>
    setUpdatedFloorId: React.Dispatch<React.SetStateAction<number | null>>
    setFloorFormData: React.Dispatch<React.SetStateAction<ParkingCampusFloor>>
}

const CampusFloorDetails = ({
                                campusId,
                                setFloorsModal,
                                setUpdatedFloorId,
                                setFloorFormData,
                            }: CampusFloorDetailsProps) => {
    const [expandedRows, setExpandedRows] = useState<any | undefined>(undefined);
    const toastRef = React.useRef<Toast | null>(null);
    const floorDataDeleteId = useRef<number>(0)


    const endpoint = `/vehicle-parking-campuses/${campusId}`;
    const [update, setUpdate] = useState<boolean>(false)
    const {data: tableDataList, loading } = useFetch(endpoint, [campusId, update]);
    const startEndpoint = `/vehicle-parking-campuses/`;
    const finalEndpoint = `/floors-delete`
    const {accessToken} = useContext(LayoutContext)


    const allowExpansion = (rowData: any) => {
        return rowData?.floor_description?.length > 0;
    };

    const accept = () => {
        const deleteParams = {
            id: floorDataDeleteId.current,
            startEndpoint: startEndpoint,
            finalEndpoint: finalEndpoint,
            name: "Floor",
            setUpdate: setUpdate,
            token: accessToken,
            toast: toastRef,
        }
        console.log('deleteParams', deleteParams);
        handleDelete(deleteParams).then()
    }

    // const accept = () => {
    //     const deleteParams = {
    //         id: selectedEvents,
    //         endPoint: deleteTableDataEndpointUrl,
    //         name: mainTitle,
    //         toast: toast,
    //         token: accessToken,
    //         data: tableDataList,
    //         update: refresh,
    //         setUpdate: setRefresh,
    //         currentPage: page,
    //         setCurrentPage: setPage,
    //         router: router
    //     }
    //     handleDelete(deleteParams).then()
    // }


    const actionTemplate = (rowData: any) => {
        return (
            <div className={'flex align-items-center justify-content-end gap-2'}>
                {/*edit button*/}
                <Button
                    icon={'pi pi-pencil'}
                    tooltip={'Edit'}
                    className={'border-rounded w-2rem h-2rem'}
                    outlined
                    onClick={() => {
                        console.log('rowData for floor', rowData);
                        // const updatedStatus = rowData.status === 1 ? {id: 1, name: 'Active'} : {id: 0, name: 'Inactive'};
                        setUpdatedFloorId(rowData?.id);
                        setFloorFormData({
                            id: rowData?.id,
                            floor_name: rowData?.floor_name,
                            floor_level: rowData?.floor_level,
                            floor_description: rowData?.floor_description
                        });
                        setFloorsModal(true);
                    }}
                />
                {/*    Add floors button*/}
                <Button
                    icon={'pi pi-trash'}
                    tooltip={'Delete Floors'}
                    className={'border-rounded w-2rem h-2rem'}
                    outlined
                    onClick={(event: any) => {
                        console.log('rowData for floor', rowData);
                        // setDeletedFloorId(rowData?.id);
                        floorDataDeleteId.current = rowData?.id;
                        confirmPopup({
                            target: event.currentTarget,
                            message: `Do you want to delete this floor?`,
                            // message: `Do you want to delete this ${mainTitle.toLowerCase()}`,
                            icon: 'pi pi-info-circle',
                            acceptClassName: 'p-button-danger',
                            accept,
                            onHide() {
                                floorDataDeleteId.current = 0;
                            }
                        })
                    }}
                    // onClick={() => {
                    //     setDeletedFloorId(rowData?.id);
                    // }}
                />
            </div>
        )
    }

    const rowExpansionTemplate = (data: any) => {
        return (
            <div className="p-4  rounded-md shadow-sm">
                <h6 className="text-lg font-semibold mb-2 text-gray-700 flex items-center gap-2">
                    Description
                </h6>
                <p className="text-gray-600 text-base">{data?.floor_description}</p>
            </div>
        );
    };

    return (
        <>
            <ConfirmPopup/>
            <Toast ref={toastRef}/>
            <h6 className="font-bold mb-3">Floor Details</h6>
            <DataTable
                value={tableDataList?.floors}
                dataKey="id"
                paginator={tableDataList?.length > 0}
                lazy
                // first={(page - 1) * limitData}
                totalRecords={tableDataList?.floors?.length}
                rows={5} rowsPerPageOptions={[5, 10, 25, 50]}
                loading={loading}
                // onPage={handlePageChange}

                expandedRows={expandedRows}
                onRowToggle={(e: DataTableRowToggleEvent) => setExpandedRows(e?.data)}
                rowExpansionTemplate={rowExpansionTemplate}
            >
                <Column expander={allowExpansion} style={{width: '3rem'}}/>
                <Column field="floor_name" header="Floor Name" style={{width: '40%'}}/>
                <Column field="floor_level" header="Level" style={{width: '40%'}}/>
                <Column header="Action" body={actionTemplate} headerClassName={"flex justify-content-end"}/>

            </DataTable>

        </>
    );
};

export default CampusFloorDetails;